// extracted by mini-css-extract-plugin
export var copyableField = "_nv-4";
export var customerBadge = "_nv-0";
export var customerInfoTitle = "_nv-2";
export var details = "_nv-1";
export var dropdownContainer = "_nv-5";
export var dropdownImage = "_nv-6";
export var editAssigneeForm = "_nv-a";
export var editButton = "_nv-3";
export var email = "_nv-7";
export var hidden = "_nv-d";
export var input = "_nv-8";
export var saveButton = "_nv-b";
export var shopifyIcon = "_nv-c";
export var suggestionBadge = "_nv-e";
export var suggestionText = "_nv-f";
export var username = "_nv-9";